  <div id="background" *ngFor="let speaker of spreker">
    <a routerLink="/">
      <img src="../../assets/logowhite.svg" alt="dots n pix logo" id="logoSmall">
    </a>

    <div class="picture"><img [src]="speaker['image']" alt=""></div>
    <div class="triangle"></div>

    <div class="building">
      <div class="door"></div>
      <div class="floors">
        <div class="floor" *ngFor="let i of [0,1,2,3,4,5,6]">
          <div class="windows">
            <div class="window"></div>
            <div class="window"></div>
            <div class="window"></div>
            <div class="window"></div>
            <div class="window"></div>
            <div class="window"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <h1>{{speaker['name']}}</h1>
      <p>{{speaker['bio']}}</p>
    </div>

    <div class="ground">
      <div class="works">
        <img *ngFor="let work of speaker['works']" [src]="work" alt="Work by {{speaker['name']}}">
      </div>
      <div class="social">
        <a [href]="speaker['facebook']">
          <i class="fab fa-facebook-square icon"></i>
        </a>
        <a [href]="speaker['instagram']">
          <i class="fab fa-instagram-square icon"></i>
        </a>
        <a [href]="speaker['website']">
          <i class="rocket-icon icon"></i>
        </a>
      </div>

      <a appTicketRocket>
        <img src="../../assets/rockettickets.png" alt="buy tickets" class="tickets">
      </a>
      <img src="../../assets/arrow.svg" alt="arrow" id="arrow">
      <p id="coaching">With the option for a coaching session with {{speaker['name']}}!</p>
    </div>

  </div>
